export default "__VITE_ASSET__BVCPoyak__"